/** 主图创建任务进度：工作台与详情页共享（避免详情页只能等轮询、成品图一次性出现） */

const listenersByTask = new Map();

export function subscribeGoodsTaskProgress(taskId, handler) {
  const id = String(taskId || '').trim();
  if (!id || typeof handler !== 'function') {
    return () => {};
  }
  if (!listenersByTask.has(id)) {
    listenersByTask.set(id, new Set());
  }
  const set = listenersByTask.get(id);
  set.add(handler);
  return () => {
    set.delete(handler);
    if (set.size === 0) listenersByTask.delete(id);
  };
}

export function publishGoodsTaskProgress(taskId, payload) {
  const id = String(taskId || '').trim();
  if (!id || !payload) return;
  const set = listenersByTask.get(id);
  if (!set) return;
  set.forEach((handler) => {
    try {
      handler(payload);
    } catch (e) {
      console.warn('[主图创建进度] 订阅回调异常', e);
    }
  });
}
